import React, { useCallback, useEffect, useState } from 'react';

import { MenuItem, Select } from '@material-ui/core';
import { generateCSVDataApi } from 'api/analytics/goal';
import styled from 'styled-components';
import { StyledBox, StyledTypography, StyledBorderedPaper } from 'styles/common';
import { checkUserIsGoalAdmin, checkUserIsHRISManager } from 'utils/helpers/rolesAccess';

import { KH_LINKS } from 'constants/knowledgeHubLinks';
import { localStorageKeys } from 'constants/localStorageKeys';
import { sendDownloadCSVEvent, sendSelectedGroupByEvent } from 'constants/mixpanelHelper';

// import { getFilters } from 'services/analytics/goal';
import TooltipInfo from 'uiToolkit/TooltipInfo';

import { FilterBarLoader } from '../commonComponents';
import DownloadCSVData from '../commonComponents/DownloadCSVData';
import { useGoalAnalytics } from './GoalAnalyticsContext';

/**
 * @deprecated 06-08-2024
 */
const FilterBar = ({ isDisabled = false }) => {
  const {
    state: { allCohorts, allGroupByKeys, allSplitByKeys, currentState },
    selectCohort,
    selectGroupBy,
    selectSplitByKey,
    initializeState,
    addCohort,
  } = useGoalAnalytics();

  const {
    selectedCohort,
    selectedGroupByKey,
    selectedSplitByKey,
    selectedSource,
    selectedFilter,
    selectedTimeBoundPeriods = null,
  } = currentState;

  const isGoalAdminOrManager = checkUserIsGoalAdmin() || checkUserIsHRISManager();
  const [loading, setLoading] = useState(true);

  const generateCSVData = useCallback(() => {
    sendDownloadCSVEvent({
      eventProperties: {
        source: 'Goals',
        type: selectedGroupByKey.displayName,
      },
    });
    return generateCSVDataApi({
      cohort: selectedCohort,
      groupByKeys: selectedGroupByKey,
      source: selectedSource,
      filter: selectedFilter,
      timeBounds: selectedTimeBoundPeriods,
    });
  }, [selectedCohort, selectedGroupByKey, selectedSource, selectedFilter, selectedTimeBoundPeriods]);

  const fetchFilters = () => {
    setLoading(true);
    // getFilters()
    //   .then((res) => {
    //     const dataInLS = getFiltersFromLS(res, localStorageKeys.analyticsGoalFilters) ?? {};
    //     const allowedGroupByKeys = isGoalAdminOrManager
    //       ? res.groupByKeys
    //       : res.groupByKeys.filter(({ keyName }) => keyName !== 'employeeId');

    //     if (allowedGroupByKeys.findIndex(({ keyName }) => keyName === dataInLS?.groupByFromLS?.keyName) === -1) {
    //       setFiltersToLS(
    //         localStorageKeys.analyticsGoalFilters,
    //         ANALYTICS_FILTERS_KEYS.groupByKey,
    //         allowedGroupByKeys[0]?.keyName
    //       );
    //     }
    //     initializeState({
    //       ...res,
    //       selectedCohort: dataInLS.cohortFromLS ?? null,
    //       groupByKeys: allowedGroupByKeys,
    //       selectedGroupByKey: dataInLS.groupByFromLS ?? null,
    //     });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  return (
    <StyledBorderedPaper padding="1rem" flexcontainer alignitems="center" bottomGutter={2}>
      {loading ? (
        <FilterBarLoader />
      ) : (
        <>
          <StyledBox display="flex" alignItems="center" rightGutter={3}>
            <StyledTypography variant="body1" color="textSecondary" rightGutter={2}>
              Group by :
            </StyledTypography>
            <StyledSelect
              disabled={isDisabled}
              variant="outlined"
              displayEmpty
              value={selectedGroupByKey}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
              }}
              onChange={({ target }) => {
                selectGroupBy(target.value);
                sendSelectedGroupByEvent({
                  eventProperties: { type: target?.value?.displayName, source: 'Goals' },
                });
              }}
            >
              {allGroupByKeys.map((groupBy, index) => (
                <MenuItem key={`groupByKey-option-${index}`} value={groupBy}>
                  <StyledTypography style={{ whiteSpace: 'normal' }} variant="body1">
                    {groupBy.displayName}
                  </StyledTypography>
                </MenuItem>
              ))}
            </StyledSelect>
            <TooltipInfo
              leftGutter={1}
              title={
                selectedGroupByKey?.keyName === 'objective'
                  ? KH_LINKS.GROUPING_OBJECTIVE.description
                  : KH_LINKS.GROUPING_INDIVIDUAL.description
              }
              linkUrl={
                selectedGroupByKey?.keyName === 'objective'
                  ? KH_LINKS.GROUPING_OBJECTIVE.url
                  : KH_LINKS.GROUPING_INDIVIDUAL.url
              }
            />
          </StyledBox>
          <StyledBox display="flex" alignItems="center" rightGutter={3}>
            <StyledTypography variant="body1" color="textSecondary" rightGutter={2}>
              Split by :
            </StyledTypography>
            <StyledSelect
              disabled
              variant="outlined"
              displayEmpty
              value={selectedSplitByKey}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
              }}
              onChange={({ target }) => {
                console.log('changed group by', target.value);

                selectSplitByKey(target.value);
              }}
            >
              {allSplitByKeys.map((groupBy, index) => (
                <MenuItem key={`groupByKey-option-${index}`} value={groupBy}>
                  <StyledTypography style={{ whiteSpace: 'normal' }} variant="body1">
                    {groupBy.displayName}
                  </StyledTypography>
                </MenuItem>
              ))}
            </StyledSelect>
          </StyledBox>
          {isGoalAdminOrManager && (
            <DownloadCSVData
              localStorageKey={localStorageKeys.analyticsGoalsCSVDownloads}
              downloadText="Download Goal Data"
              generateCSVData={generateCSVData}
            />
          )}
        </>
      )}
    </StyledBorderedPaper>
  );
};

const StyledSelect = styled(Select)`
  .MuiSelect-root {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.75rem;
  }
`;
export default FilterBar;
